import {IndexedDBCache, Tracker} from "finhelper"
import {createReducer} from 'redux-act'

import { clearAuthTokensFromStorage, saveAuthSessionSnapshot } from '#app/shared/lib/auth/authSessionStorage';
import * as actions from '#app/store/actions/auth'
import type {AuthApiResponse} from '#app/store/actions/auth'

export interface AuthState {
  data: Record<string, any>;
  auth: boolean;
  showLoginModal: boolean;
  showRegisterModal: boolean;
  showForgotModal: boolean;
  avatar: string;
}

const user: AuthState = {
  data: {},
  auth: false,
  showLoginModal: false,
  showRegisterModal: false,
  showForgotModal: false,
  avatar: process.env.REACT_APP_API_URL + '/images/avatar/default.svg',
};

const handleGetUser = (state: AuthState, response: AuthApiResponse): AuthState => {

  if(typeof response === 'object' && response.result === 'success')
  {
    saveAuthSessionSnapshot(response.data ?? {});

    return {
      ...state,
      data: response.data ?? {},
      auth: true
    }
  }else{
    return state;
  }
}

const handleLogout = (state: AuthState): AuthState => {
  clearAuthTokensFromStorage();
  IndexedDBCache.clearAll();

  return {
    ...state,
    data: {},
    auth: false
  }
}

const handleLoginModal = (state: AuthState): AuthState => {
  return {
    ...state,
    showLoginModal: true,
    showRegisterModal: false,
    showForgotModal: false,
  }
}

const handleForgotModal = (state: AuthState): AuthState => {
  return {
    ...state,
    showForgotModal: true,
    showLoginModal: false,
    showRegisterModal: false,
  }
}

const handleRegisterModal = (state: AuthState): AuthState => {
  Tracker.reachGoal('register_click', {});

  return {
    ...state,
    showRegisterModal: true,
    showForgotModal: false,
    showLoginModal: false,
  }
}

const handleCloseModal = (state: AuthState): AuthState => {
  return {
    ...state,
    showLoginModal: false,
    showRegisterModal: false,
    showForgotModal: false,
  }
}

const reducer = createReducer<AuthState>((on) => {
  on(actions.handleGetUser, handleGetUser);
  on(actions.handleLogout, handleLogout);
  on(actions.handleLoginModal, handleLoginModal);
  on(actions.handleForgotModal, handleForgotModal);
  on(actions.handleRegisterModal, handleRegisterModal);
  on(actions.handleCloseModal, handleCloseModal);
}, user)

export default reducer
